import axios from 'axios';
import { DC_FORM_SENDER_APPLICATIONS_FINISH } from '@alfa-bank/site-dc-env-config';

import type { TDeliveryFinishArgs, IFinishResponse } from '../models/api';

export const finishApi = ({ appId, businessUid, ...data }: TDeliveryFinishArgs) => {
    return axios.post<IFinishResponse>(DC_FORM_SENDER_APPLICATIONS_FINISH({ appId }), data, {
        headers: {
            'Content-Type': 'application/json',
            BusinessUid: businessUid,
        },
    });
};
